import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instance3jaj4elqoxne0 as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contentType2zzm38yxo3syt as contentType } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  toString30pk9tzaqopn as toString_0,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { trimMarginhyd3fsmh8iev as trimMargin } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { get_MaxRetriesPerRequestAttributeKey13gphm9kuo852 as get_MaxRetriesPerRequestAttributeKey } from './HttpRequestRetry.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import { cancel36mj9lv3a0whl as cancel } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from '../call/HttpClientCall.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpSend$Plugin$install$slambdaClass;
function HttpSend$Plugin$install$slambda() {
  if (HttpSend$Plugin$install$slambdaClass === VOID) {
    class $ {
      constructor($plugin, $scope) {
        this.f5y_1 = $plugin;
        this.g5y_1 = $scope;
      }
      *h5l($this$intercept, content, $completion) {
        // Inline function 'kotlin.check' call
        if (!(content instanceof OutgoingContent())) {
          var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(content)) + ', with Content-Type: ' + toString_0(contentType($this$intercept.w4w_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'io.ktor.client.request.setBody' call
        var this_0 = $this$intercept.w4w_1;
        if (content == null) {
          this_0.n5n_1 = NullBody_instance;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp = getKClass(OutgoingContent());
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_0;
          try {
            tmp_0 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
              var _unused_var__etf5q3 = $p;
              tmp_1 = null;
            } else {
              throw $p;
            }
            tmp_0 = tmp_1;
          }
          var tmp$ret$4 = tmp_0;
          var tmp$ret$3 = new (TypeInfo())(tmp, tmp$ret$4);
          this_0.g5r(tmp$ret$3);
        } else {
          if (content instanceof OutgoingContent()) {
            this_0.n5n_1 = content;
            this_0.g5r(null);
          } else {
            this_0.n5n_1 = content;
            // Inline function 'io.ktor.util.reflect.typeInfo' call
            var tmp_2 = getKClass(OutgoingContent());
            // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
            var tmp_3;
            try {
              tmp_3 = createKType(getKClass(OutgoingContent()), arrayOf([]), false);
            } catch ($p) {
              var tmp_4;
              if ($p instanceof Error) {
                var _unused_var__etf5q3_0 = $p;
                tmp_4 = null;
              } else {
                throw $p;
              }
              tmp_3 = tmp_4;
            }
            var tmp$ret$6 = tmp_3;
            var tmp$ret$5 = new (TypeInfo())(tmp_2, tmp$ret$6);
            this_0.g5r(tmp$ret$5);
          }
        }
        var maxRetries = $this$intercept.w4w_1.p5n_1.j4r(get_MaxRetriesPerRequestAttributeKey());
        var tmp_5;
        if (!(maxRetries == null) && maxRetries >= this.f5y_1.h5y_1) {
          var tmp_6;
          if (maxRetries < 2147483647) {
            tmp_6 = maxRetries + 1 | 0;
          } else {
            tmp_6 = maxRetries;
          }
          tmp_5 = tmp_6;
        } else {
          tmp_5 = this.f5y_1.h5y_1;
        }
        var maxSendCount = tmp_5;
        var realSender = new (DefaultSender())(maxSendCount, this.g5y_1);
        var interceptedSender = realSender;
        var _iterator__ex2g4s = reversed(this.f5y_1.i5y_1).p1();
        while (_iterator__ex2g4s.q1()) {
          var interceptor = _iterator__ex2g4s.r1();
          interceptedSender = new (InterceptedSender())(interceptor, interceptedSender);
        }
        var call = yield* interceptedSender.j5y($this$intercept.w4w_1, $completion);
        yield* $this$intercept.y4v(call, $completion);
        return Unit_instance;
      }
      pd(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.h5l(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpSend$Plugin$install$slambdaClass = $;
  }
  return HttpSend$Plugin$install$slambdaClass;
}
function HttpSend$Plugin$install$slambda_0($plugin, $scope) {
  var i = new (HttpSend$Plugin$install$slambda())($plugin, $scope);
  var l = ($this$intercept, content, $completion) => i.h5l($this$intercept, content, $completion);
  l.$arity = 2;
  return l;
}
var ConfigClass;
function Config() {
  if (ConfigClass === VOID) {
    class $ {
      constructor() {
        this.k5y_1 = 20;
      }
    }
    initMetadataForClass($, 'Config', Config);
    ConfigClass = $;
  }
  return ConfigClass;
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'HttpSend';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(HttpSend());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(HttpSend()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.l5y_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      m3() {
        return this.l5y_1;
      }
      m5y(block) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Config())();
        block(this_0);
        var config = this_0;
        return new (HttpSend())(config.k5y_1);
      }
      r5n(block) {
        return this.m5y(block);
      }
      n5y(plugin, scope) {
        var tmp = Phases_getInstance().d5s_1;
        scope.o5l_1.a4x(tmp, HttpSend$Plugin$install$slambda_0(plugin, scope));
      }
      s5n(plugin, scope) {
        return this.n5y(plugin instanceof HttpSend() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var InterceptedSenderClass;
function InterceptedSender() {
  if (InterceptedSenderClass === VOID) {
    class $ {
      constructor(interceptor, nextSender) {
        this.o5y_1 = interceptor;
        this.p5y_1 = nextSender;
      }
      *j5y(requestBuilder, $completion) {
        return yield* this.o5y_1(this.p5y_1, requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'InterceptedSender', VOID, VOID, [Sender()], [1]);
    InterceptedSenderClass = $;
  }
  return InterceptedSenderClass;
}
var DefaultSenderClass;
function DefaultSender() {
  if (DefaultSenderClass === VOID) {
    class $ {
      constructor(maxSendCount, client) {
        this.q5y_1 = maxSendCount;
        this.r5y_1 = client;
        this.s5y_1 = 0;
        this.t5y_1 = null;
      }
      *j5y(requestBuilder, $completion) {
        var tmp0_safe_receiver = this.t5y_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          cancel(tmp0_safe_receiver);
        }
        if (this.s5y_1 >= this.q5y_1) {
          throw SendCountExceedException().y5y('Max send count ' + this.q5y_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
        }
        this.s5y_1 = this.s5y_1 + 1 | 0;
        var sendResult = yield* this.r5y_1.q5l_1.v4w(requestBuilder, requestBuilder.n5n_1, $completion);
        var tmp1_elvis_lhs = sendResult instanceof HttpClientCall() ? sendResult : null;
        var tmp;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var call = tmp;
        this.t5y_1 = call;
        return call;
      }
    }
    initMetadataForClass($, 'DefaultSender', VOID, VOID, [Sender()], [1]);
    DefaultSenderClass = $;
  }
  return DefaultSenderClass;
}
var HttpSendClass;
function HttpSend() {
  if (HttpSendClass === VOID) {
    class $ {
      constructor(maxSendCount) {
        Plugin_getInstance();
        maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
        this.h5y_1 = maxSendCount;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.i5y_1 = ArrayList().p2();
      }
      z5y(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.i5y_1.i2(block);
      }
    }
    initMetadataForClass($, 'HttpSend');
    HttpSendClass = $;
  }
  return HttpSendClass;
}
var SenderClass;
function Sender() {
  if (SenderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Sender', VOID, VOID, VOID, [1]);
    SenderClass = $;
  }
  return SenderClass;
}
var SendCountExceedExceptionClass;
function SendCountExceedException() {
  if (SendCountExceedExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static y5y(message) {
        var $this = this.o(message);
        captureStack($this, $this.x5y_1);
        return $this;
      }
    }
    initMetadataForClass($, 'SendCountExceedException');
    SendCountExceedExceptionClass = $;
  }
  return SendCountExceedExceptionClass;
}
//region block: exports
export {
  Plugin_getInstance as Plugin_getInstance1dclwrituae7c,
  Sender as Sender4pyqqer9k7up,
};
//endregion

//# sourceMappingURL=HttpSend.mjs.map
